// pattern: Functional Core

import { html } from 'htm/preact'
import { type FunctionComponent } from 'preact'

export const IconCheck:FunctionComponent = function () {
    return html`<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="square"
        stroke-linejoin="miter"
        class="icon icon-check"
        aria-hidden="true"
    >
        <path
            class="icon-check-path"
            d="M4 12.5 L10 18.5 L20 6.5"
        />
    </svg>`
}
